import { render, staticRenderFns } from "./crudInstancesServer.vue?vue&type=template&id=76e073a4&"
import script from "./crudInstancesServer.vue?vue&type=script&lang=js&"
export * from "./crudInstancesServer.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports